export interface PriceRange {
  min: number;
  max: number;
  avg: number;
}

export interface PriceHistory {
  year: number;
  label: string;
  pricePerSqm: number;
}

export interface RegionPriceData {
  name: string;
  segment: 'alto' | 'medio' | 'economico';
  basePrice: number;
  byTypology: Record<string, PriceRange>;
  plantaMultiplier: number;
  description: string;
  history: PriceHistory[];
}

export const regions: RegionPriceData[] = [
  {
    name: 'Plano Piloto (Asa Sul, Asa Norte, Lago Sul, Lago Norte)',
    segment: 'alto',
    basePrice: 15200,
    plantaMultiplier: 1.55,
    description: 'Alto padrão, forte liquidez para investidores',
    byTypology: {
      kitnet: { min: 14000, max: 18500, avg: 16200 },
      '1q': { min: 14500, max: 19000, avg: 16700 },
      '2q': { min: 13800, max: 17000, avg: 15200 },
      '3q': { min: 13500, max: 16500, avg: 14800 },
      '4q': { min: 15000, max: 22000, avg: 17800 },
    },
    history: [
      { year: 2023, label: '2023', pricePerSqm: 13900 },
      { year: 2024, label: '2024', pricePerSqm: 14400 },
      { year: 2025, label: '2025', pricePerSqm: 15000 },
      { year: 2026, label: '2026', pricePerSqm: 15200 },
    ],
  },
  {
    name: 'Noroeste',
    segment: 'alto',
    basePrice: 18200,
    plantaMultiplier: 1.5,
    description: 'Alto padrão, apartamentos 3 e 4 quartos dominam',
    byTypology: {
      kitnet: { min: 16500, max: 21000, avg: 18800 },
      '1q': { min: 17000, max: 21500, avg: 19200 },
      '2q': { min: 16500, max: 20000, avg: 18000 },
      '3q': { min: 17000, max: 24000, avg: 19500 },
      '4q': { min: 18500, max: 26000, avg: 21500 },
    },
    history: [
      { year: 2023, label: '2023', pricePerSqm: 16600 },
      { year: 2024, label: '2024', pricePerSqm: 17200 },
      { year: 2025, label: '2025', pricePerSqm: 17800 },
      { year: 2026, label: '2026', pricePerSqm: 18200 },
    ],
  },
  {
    name: 'Sudoeste',
    segment: 'alto',
    basePrice: 20500,
    plantaMultiplier: 1.55,
    description: 'Lidera valorização no DF, novos > R$ 26.000/m²',
    byTypology: {
      kitnet: { min: 18500, max: 23000, avg: 20800 },
      '1q': { min: 19000, max: 24000, avg: 21500 },
      '2q': { min: 18500, max: 22500, avg: 20000 },
      '3q': { min: 19500, max: 27000, avg: 22500 },
      '4q': { min: 21000, max: 29000, avg: 24500 },
    },
    history: [
      { year: 2023, label: '2023', pricePerSqm: 18700 },
      { year: 2024, label: '2024', pricePerSqm: 19400 },
      { year: 2025, label: '2025', pricePerSqm: 20000 },
      { year: 2026, label: '2026', pricePerSqm: 20500 },
    ],
  },
  {
    name: 'Águas Claras',
    segment: 'medio',
    basePrice: 10800,
    plantaMultiplier: 1.45,
    description: 'Principal motor de volume de vendas do DF',
    byTypology: {
      kitnet: { min: 9500, max: 13000, avg: 11200 },
      '1q': { min: 10000, max: 13500, avg: 11600 },
      '2q': { min: 9800, max: 12500, avg: 10800 },
      '3q': { min: 10500, max: 14000, avg: 11800 },
      '4q': { min: 11500, max: 15500, avg: 13200 },
    },
    history: [
      { year: 2023, label: '2023', pricePerSqm: 9900 },
      { year: 2024, label: '2024', pricePerSqm: 10200 },
      { year: 2025, label: '2025', pricePerSqm: 10500 },
      { year: 2026, label: '2026', pricePerSqm: 10800 },
    ],
  },
  {
    name: 'Guará',
    segment: 'medio',
    basePrice: 10200,
    plantaMultiplier: 1.4,
    description: 'Boa liquidez, preço ligeiramente acima da média',
    byTypology: {
      kitnet: { min: 8800, max: 12000, avg: 10400 },
      '1q': { min: 9200, max: 12500, avg: 10800 },
      '2q': { min: 9000, max: 11500, avg: 10000 },
      '3q': { min: 9800, max: 13000, avg: 11200 },
      '4q': { min: 10500, max: 14000, avg: 12000 },
    },
    history: [
      { year: 2023, label: '2023', pricePerSqm: 9300 },
      { year: 2024, label: '2024', pricePerSqm: 9700 },
      { year: 2025, label: '2025', pricePerSqm: 10000 },
      { year: 2026, label: '2026', pricePerSqm: 10200 },
    ],
  },
  {
    name: 'Taguatinga',
    segment: 'medio',
    basePrice: 9500,
    plantaMultiplier: 1.4,
    description: 'Mercado em crescimento, boa relação custo-benefício',
    byTypology: {
      kitnet: { min: 8200, max: 11000, avg: 9600 },
      '1q': { min: 8500, max: 11500, avg: 9900 },
      '2q': { min: 8300, max: 10800, avg: 9400 },
      '3q': { min: 9000, max: 12000, avg: 10200 },
      '4q': { min: 9500, max: 13000, avg: 11000 },
    },
    history: [
      { year: 2023, label: '2023', pricePerSqm: 8700 },
      { year: 2024, label: '2024', pricePerSqm: 9000 },
      { year: 2025, label: '2025', pricePerSqm: 9300 },
      { year: 2026, label: '2026', pricePerSqm: 9500 },
    ],
  },
  {
    name: 'Santa Maria',
    segment: 'economico',
    basePrice: 5800,
    plantaMultiplier: 1.35,
    description: 'Foco em apartamentos 2Q enquadrados em programas habitacionais',
    byTypology: {
      kitnet: { min: 4800, max: 6800, avg: 5800 },
      '1q': { min: 5000, max: 7000, avg: 6000 },
      '2q': { min: 5200, max: 7200, avg: 6100 },
      '3q': { min: 5500, max: 7800, avg: 6500 },
      '4q': { min: 6000, max: 8500, avg: 7200 },
    },
    history: [
      { year: 2023, label: '2023', pricePerSqm: 5300 },
      { year: 2024, label: '2024', pricePerSqm: 5500 },
      { year: 2025, label: '2025', pricePerSqm: 5700 },
      { year: 2026, label: '2026', pricePerSqm: 5800 },
    ],
  },
  {
    name: 'Samambaia',
    segment: 'economico',
    basePrice: 5500,
    plantaMultiplier: 1.3,
    description: 'Grande parte do VGV de imóveis econômicos',
    byTypology: {
      kitnet: { min: 4500, max: 6500, avg: 5500 },
      '1q': { min: 4700, max: 6700, avg: 5700 },
      '2q': { min: 4800, max: 6800, avg: 5800 },
      '3q': { min: 5200, max: 7300, avg: 6200 },
      '4q': { min: 5500, max: 7800, avg: 6600 },
    },
    history: [
      { year: 2023, label: '2023', pricePerSqm: 5000 },
      { year: 2024, label: '2024', pricePerSqm: 5200 },
      { year: 2025, label: '2025', pricePerSqm: 5400 },
      { year: 2026, label: '2026', pricePerSqm: 5500 },
    ],
  },
  {
    name: 'Planaltina',
    segment: 'economico',
    basePrice: 5300,
    plantaMultiplier: 1.3,
    description: 'Mercado econômico em expansão',
    byTypology: {
      kitnet: { min: 4300, max: 6200, avg: 5300 },
      '1q': { min: 4500, max: 6400, avg: 5500 },
      '2q': { min: 4600, max: 6500, avg: 5600 },
      '3q': { min: 4900, max: 7000, avg: 5900 },
      '4q': { min: 5200, max: 7500, avg: 6300 },
    },
    history: [
      { year: 2023, label: '2023', pricePerSqm: 4800 },
      { year: 2024, label: '2024', pricePerSqm: 5000 },
      { year: 2025, label: '2025', pricePerSqm: 5200 },
      { year: 2026, label: '2026', pricePerSqm: 5300 },
    ],
  },
];

export const typologies = [
  { value: 'kitnet', label: 'Kitnet / Studio', icon: 'ri-home-smile-line' },
  { value: '1q', label: '1 Quarto', icon: 'ri-hotel-bed-line' },
  { value: '2q', label: '2 Quartos', icon: 'ri-hotel-bed-line' },
  { value: '3q', label: '3 Quartos', icon: 'ri-hotel-bed-line' },
  { value: '4q', label: '4+ Quartos', icon: 'ri-building-line' },
];

export const conditions = [
  { value: 'novo', label: 'Novo (0-5 anos)', factor: 1.0, icon: 'ri-sparkling-line' },
  { value: 'seminovo', label: 'Seminovo (5-15 anos)', factor: 0.92, icon: 'ri-star-line' },
  { value: 'usado', label: 'Usado (+15 anos)', factor: 0.85, icon: 'ri-time-line' },
];

export const tipoVenda = [
  { value: 'pronto', label: 'Imóvel Pronto', multiplier: 1.0 },
  { value: 'planta', label: 'Na Planta / Lançamento', multiplier: 1.0 },
];

export function calculateSuggestedPrice(
  region: RegionPriceData,
  typology: string,
  area: number,
  condition: string,
  tipo: string,
): { min: number; max: number; avg: number } {
  const typologyData = region.byTypology[typology];
  if (!typologyData) return { min: 0, max: 0, avg: 0 };

  const condFactor = conditions.find((c) => c.value === condition)?.factor ?? 1.0;
  const isPlanta = tipo === 'planta';

  const plantaMult = isPlanta ? region.plantaMultiplier : 1.0;

  const min = Math.round(typologyData.min * area * condFactor * plantaMult);
  const max = Math.round(typologyData.max * area * condFactor * plantaMult);
  const avg = Math.round(typologyData.avg * area * condFactor * plantaMult);

  return { min, max, avg };
}